import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="bg-ink text-paper border-t border-white/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <Logo dark />
          <p className="mt-4 text-sm text-paper/60 leading-relaxed max-w-xs">
            Chartered Accountant in Ghaziabad/NCR — GST, Income Tax, Corporate Law and Audit for Indirapuram, Raj Nagar, Vaishali and beyond.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brass font-semibold mb-4">Navigate</p>
          <ul className="space-y-2.5 text-sm text-paper/70">
            <li><a href="#services" className="hover:text-brass transition-colors">Services</a></li>
            <li><a href="#target-locations" className="hover:text-brass transition-colors">Practice Areas</a></li>
            <li><a href="#icai-compliance" className="hover:text-brass transition-colors">ICAI Credentials</a></li>
            <li><a href="#contact" className="hover:text-brass transition-colors">Contact</a></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brass font-semibold mb-4">Reach Us</p>
          <ul className="space-y-2.5 text-sm text-paper/70">
            <li><a href="tel:+919654852550" className="hover:text-brass transition-colors">+91 96548 52550</a></li>
            <li><a href="tel:+919654852529" className="hover:text-brass transition-colors">+91 96548 52529</a></li>
            <li><a href="mailto:skch.ca@gmail.com" className="hover:text-brass transition-colors">skch.ca@gmail.com</a></li>
            <li className="text-paper/60 leading-relaxed">510, 5th Floor, Sumanglam Tower,<br />RDC Raj Nagar, Ghaziabad, UP 201002</li>
            <li className="pt-2 text-paper/50">ICAI M.No. 448639 · FRN 029777C</li>
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/10 text-xs text-paper/40 leading-relaxed">
        <p>© 2026 Shashank Chaudhary &amp; Co, Chartered Accountants. All rights reserved.</p>
        <p className="mt-2">This website complies with the ICAI website guidelines and is for information purposes only; it is not an advertisement or solicitation of professional work.</p>
      </div>
    </div>
  </footer>
);
